import { Receipt } from "lucide-react";
import { formatCurrency } from "../contexts/FxContext";

function formatDate(iso) {
    try {
        return new Date(iso).toLocaleDateString("en-GB", { year: "numeric", month: "short", day: "numeric" });
    } catch (_e) {
        return iso;
    }
}

function paymentStatusLabel(p) {
    if (p.revenue_credited) return { label: "In pool", className: "text-[#00BF0D] border-[#00BF0D]/25 bg-[#00BF0D]/10" };
    if (p.payment_status === "paid" || p.status === "complete") return { label: "Paid — syncing", className: "text-amber-300 border-amber-500/25 bg-amber-500/10" };
    return { label: p.payment_status || p.status || "Pending", className: "text-white/50 border-white/10 bg-white/[0.03]" };
}

export function ClientPayments({ payments = [], currency = "GBP" }) {
    return (
        <section className="surface p-5 sm:p-6" data-testid="client-payments">
            <div className="mb-4">
                <p className="label-eyebrow inline-flex items-center gap-1.5">
                    <Receipt className="h-3 w-3 text-[#00BF0D]" /> Client payments
                </p>
                <h3 className="font-heading text-xl sm:text-2xl tracking-tight mt-1">Money in</h3>
                <p className="text-xs text-white/45 mt-1">Checkout payments from &ldquo;Bill a client&rdquo;. Payout history below is money out to recipients.</p>
            </div>
            {payments.length === 0 ? (
                <p className="text-sm text-white/40 py-4 text-center">No client payments recorded yet.</p>
            ) : (
                <ul className="divide-y divide-white/[0.05] rounded-lg border border-white/[0.05]">
                    {payments.map((p) => {
                        const badge = paymentStatusLabel(p);
                        const gross = p.amount_paid ?? p.amount ?? 0;
                        return (
                            <li key={p.id || p.session_id} className="flex flex-wrap items-center justify-between gap-2 px-3.5 py-3" data-testid={`client-payment-${p.id || p.session_id}`}>
                                <div className="min-w-0">
                                    <p className="text-sm text-white/85 truncate">{p.client_name || "Client"}</p>
                                    <p className="text-[11px] text-white/40">{formatDate(p.created_at)}</p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className="font-mono text-sm text-[#00BF0D] tabular-nums">
                                        {formatCurrency(gross, p.currency || currency, { decimals: 2 })}
                                    </span>
                                    <span className={`fs-pill rounded-full border px-2 py-0.5 text-[10px] font-medium ${badge.className}`}>
                                        {badge.label}
                                    </span>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </section>
    );
}
